<template>
  <Dialog :value="open" :transition="transition" :closeable="closeable" v-on="$listeners">
    <template #top-tools-append v-if='!$vuetify.breakpoint.mdAndUp'>
      <ipa-toggle :display-mode='displayMode' @display-mode-changed='handleDisplayMode' :language='language'/>
    </template>
    <slot>
      <div v-if="showImage">
        <a :href="translationUrl" target="_blank">Translation</a>
        <v-img 
          max-height="1024"
          max-width="1024"
          :src="imageSrc"
        ></v-img>
      </div>
      <readonly-body v-else :text="displayText" :subtext="subtext" :speed="speed">
        <template #maintext>
          <slot name="maintext"></slot>
        </template>
        <template #subtext>
          <slot name="subtext"></slot>
        </template>
      </readonly-body>
    </slot>
    <template v-slot:actions>
      <text-to-speech-global>
        <template #right v-if='$vuetify.breakpoint.mdAndUp'>
          <ipa-toggle :display-mode='displayMode' @display-mode-changed='handleDisplayMode' :language='language'/>
        </template>
      </text-to-speech-global>
    </template>
  </Dialog>
</template>

<script>
import { defineComponent, inject, watch, computed } from 'vue';
import ReadonlyBody from './ReadonlyBody.vue';
import Dialog from '../Dialog.vue';
import IpaToggle from './IpaToggle.vue';
import TextToSpeechGlobal from '../tts/TextToSpeechGlobal.vue';

export default defineComponent({
  components: {
    Dialog,
    IpaToggle,
    ReadonlyBody,
    TextToSpeechGlobal,
  },
  props: {
    text:{
      type: String,
      required: true
    }, 
    voices:{
      type: Array,
    }, 
    voice: {},
    started: {
      required: true
    },
    ttsMode: {
      type: Boolean,
      required: true
    },
    playing: {
      type: Boolean,
      required: true
    },
    language:{
      type: String,
      required: true
    },
    displayText:{
      type: String,
      required: true
    },
    displayMode: {
      type: String,
      required: true
    },
    subtext: {
      type: String
    },
    speed: {
      type: Number,
    },
    open: {
      type: Boolean,
      default: true
    },
    closeable: {
      type: Boolean
    },
    transition: {
      type: String,
      default: ''
    }
  },
  setup(_, context){
    const showImage = inject('showImage');
    const text = inject('text');
    const translationUrl = computed(() => {
      return `https://translate.google.com/?sl=en&tl=es&text=${text.value}&op=translate`
    });
    const imageSrc = inject('imageSrc');
    const handlePlayPause = (value)=>{
      context.emit('play-pause', value);
    }
    const handleDisplayMode = (value)=>{
      context.emit('display-mode-changed', value)
    }
    const handleLastWord = (value)=>{
      context.emit('last-word', value)
    }
    const handleSpeedChange = (value)=>{
      context.emit('speed-changed', value)
    }
    const handleEndSpeech = ()=>{
      context.emit('end-speech');
    }
    const handleVoiceChanged = (value)=>{
      context.emit('voice-changed', value);
    }
    const handleTTSMode = (value)=>{
      context.emit('tts-mode-changed', value);
    }
    watch(showImage, (newBool) => {
      console.log('from watch new bool: '+ newBool);
    });
    
    return {
      showImage,
      imageSrc,
      translationUrl,
      handlePlayPause,
      handleDisplayMode,
      handleLastWord,
      handleSpeedChange,
      handleEndSpeech,
      handleVoiceChanged,
      handleTTSMode
    }
  }
})
</script>

<style lang="scss" scoped>
.speed-slider  {
  max-width: 20rem;
  flex-basis: 20rem;
  min-width: 15rem;
  flex-shrink: 1;
}
</style>
